import React, { Component } from "react";
import { Link } from "react-router-dom";

// Components
import ProductPreviewImage from "./product/ProductPreviewImage";
import ProductRating from "./product/ProductRating";
import ProductDeposit from "./product/ProductDeposit";
import ProductPriceList from "./product/ProductPriceList";

// CSS
import "../css/product-collection.css";

class ItemPreview extends Component {
	render() {
		const { product } = this.props;
		const catPermalink = product.categories ? product.categories[0].permalink + "/" : "/";
		const image = <ProductPreviewImage product={product} width={this.props.width} height={this.props.height} />;
		const prices = <ProductPriceList product={product} getFirstVariant={true} />;

		return (
			<div className="product">
				<Link to={`/${catPermalink}product/${product.permalink}`}>
					{image}

					<div className="product_title">{product.title}</div>

					{prices}

					{/* <ProductDeposit deposit={product.deposit} /> */}
					{/* <ProductRating rating={product.rating} /> */}

				</Link>
			</div>
		);
	}
}

export default ItemPreview;

//IMPORTANT READ THIS!!!!!!
//this file was useless because no products in the database had ratings. So, I changed it to being the deposit. This component is responsible for displaying
//each deposit for each product on the product screen.


// WEBPACK FOOTER //
// ./src/components/ItemPreview.js